export const ItpLabel = {
  Itp: "ITP",
  ItpFullForm: "ITP(Interns Training Program)",
  ItpDetail: "ITP Detail",
  ItpProject: "ITP Project",
  CourseName: "Course Name",
  TopicName: "Topic Name",
  URL: "URL",
  Hour: "Hour",
  NoOfTopics: "No Of Topics",
  Duration: "Duration(Hours)",
  Project: "Project",
  NewItp: "New ITP",
  Remark: "Remark",
  Link: "Link",
  NewTopic: "New Topic",
  ProjectName: "Project Name",
  Day: "Day",
  Api: "API",
  NewProject: "New Project",
  TotalDays: "Total Days",
  TotalApis: "Total APIs",
  ProjectDetails: "Project Details",
  AddItp: "Add ITP",
  UpdateItp: "Update ITP",
  ItpProjectDetail: "ITP Project Detail",
  ItpProjectModule: "ITP Project Module",
  Development: "Development",
  Module: "Module",
  ApiEndPoints: "Api EndPoints",
  FE: "FE",
  BE: "BE",
  Screen: "Screen",
  CharLimitExceed: "Character limit exceeded!",
  CharCount: "Character Count",
  CreateProject: "Create Project",
  ViewModules: "View Modules",
  ModuleErrorMessage: "Please add at least one module",
};